import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getCustomUrl, getProducts } from '../../utils/trackings_helpers';

export function trackCallButtonClick(offer: TOffer) {
  ca('eventSite', {
    action: 'Call_ChatLeadMainScreen',
    category: 'Phones',
    label: 'agent',
    name: 'oldevent',
    page: {
      customPageURL: getCustomUrl(offer),
    },
    products: offer ? getProducts([offer]) : [],
  });
}
